import { BARIENDO_CT_SYSTEM, TaskGroupIdentifier, TaskStatus } from '@bariendo/lib/constants';
import { MedplumClient, WithId, getReferenceString } from '@medplum/core';
import { Patient, Practitioner, Reference, Task } from '@medplum/fhirtypes';

export function mountConversationLeadTaskBaseQuery(patientRef: Reference<Patient>): Record<string, any> {
  return {
    'group-identifier': `${BARIENDO_CT_SYSTEM}|${TaskGroupIdentifier.CONVERSATION_LEAD}`,
    patient: getReferenceString(patientRef),
    status: TaskStatus.IN_PROGRESS,
    _sort: '-authored-on',
  };
}

export async function getActiveConversationLeadTask(
  medplum: MedplumClient,
  patientRef: Reference<Patient>
): Promise<WithId<Task> | undefined> {
  return medplum.searchOne('Task', mountConversationLeadTaskBaseQuery(patientRef));
}

export async function getPatientConversationLead(
  medplum: MedplumClient,
  patientRef: Reference<Patient>
): Promise<Reference<Practitioner> | undefined> {
  return (await getActiveConversationLeadTask(medplum, patientRef))?.owner as Reference<Practitioner> | undefined;
}
